---
title: Voice quickstart
summary: Turn on voice for a persona and have your first spoken conversation.
visibility: authenticated
feature: voice
audience: author-admin
section: Get started
order: 20
last_verified: 2026-06-19
owner: docs
---

# Voice quickstart

This persona supports **voice**. You can talk to it and hear it respond.

<FeatureGate feature="avatars">

If avatars are also enabled, you can take the conversation further with a
video avatar — see the Avatar setup guide.

</FeatureGate>

To start a voice conversation, open the persona and choose the microphone mode
(push-to-talk or open-mic).
